import React from 'react';
import get from 'lodash/get';
import Chip from '@material-ui/core/Chip';
import EventIcon from '@material-ui/icons/Event';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import InfoIcon from '@material-ui/icons/Info';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ReportIcon from '@material-ui/icons/Report';
import { getCompatibleTextColor } from '../../calendar/colors';

const StatusChipField = ({ record, status = null }) => {
 
  let workStatus = get(record, 'status');
  const red = '#E93F43';
  const green = '#00A76F';
  const grey = '#e0e0e0';
  const blue = '#479BA0';
  const yellow = '#FFD666';
  const liteGreen = 'rgba(34, 197, 94, 0.16)';

  let backgroundColor = grey;
  let icon = (

    <svg style={{width: '16px', height: '16px' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path opacity="0.5" d="M14.6667 9.33333V8C14.6667 7.44067 14.658 6.44333 14.6493 6H1.33735C1.32868 6.44333 1.33735 7.44067 1.33735 8V9.33333C1.33735 11.8473 1.33735 13.1047 2.11735 13.8853C2.89935 14.6667 4.15601 14.6667 6.66935 14.6667H9.33601C11.8493 14.6667 13.1053 14.6667 13.8867 13.8853C14.6667 13.1047 14.6667 11.8473 14.6667 9.33333Z" fill="#118D57"/>
    <path d="M4.64016 1.33325C4.91883 1.33325 5.14416 1.53992 5.14416 1.79459V2.72659C5.59083 2.71859 6.09216 2.71859 6.65616 2.71859H9.34416C9.90816 2.71859 10.4088 2.71859 10.8562 2.72659V1.79459C10.8562 1.53992 11.0815 1.33325 11.3602 1.33325C11.6388 1.33325 11.8642 1.53992 11.8642 1.79459V2.76659C12.8308 2.83725 13.4662 3.01192 13.9328 3.43859C14.3995 3.86592 14.5895 4.44725 14.6668 5.33325V5.99992H1.3335V5.33325C1.41083 4.44725 1.60083 3.86659 2.0675 3.43859C2.53416 3.01192 3.16883 2.83725 4.13616 2.76659V1.79459C4.13616 1.53992 4.36216 1.33325 4.64016 1.33325Z" fill="#118D57"/>
    <path d="M12.0002 10.9999C12.0002 11.2651 11.8948 11.5195 11.7073 11.707C11.5197 11.8946 11.2654 11.9999 11.0002 11.9999C10.7349 11.9999 10.4806 11.8946 10.2931 11.707C10.1055 11.5195 10.0002 11.2651 10.0002 10.9999C10.0002 10.7347 10.1055 10.4803 10.2931 10.2928C10.4806 10.1053 10.7349 9.99992 11.0002 9.99992C11.2654 9.99992 11.5197 10.1053 11.7073 10.2928C11.8948 10.4803 12.0002 10.7347 12.0002 10.9999Z" fill="#118D57"/>
    </svg>
  );
  if (!workStatus && !status) {
    return null;
  }

  // This conditional block handles status for ScheduledWorks and Services
  if (workStatus === 'keys_available' || status === 'keys_available') {
    backgroundColor = blue;
    icon = (
      <VpnKeyIcon style={{ color: '#ffffff', width: '16px', height: '16px' }} />
    );
  } else if (workStatus === 'cancelled' || status === 'cancelled') {
    backgroundColor = yellow;
    icon = (
      <ReportIcon style={{ color: '#181818', width: '16px', height: '16px' }} />
    );
  } else if ((workStatus === 'finished' || status === 'finished')) {
    workStatus = 'Complete';
    status = 'Complete';
    backgroundColor = green;
    icon = (
      <CheckCircleOutlineIcon
        style={{ color: '#ffffff', width: '16px', height: '16px' }}
      />
    );
  } else if (workStatus === 'suggested' || status === 'suggested') {
    backgroundColor = yellow;
    icon = (
      <InfoIcon style={{ color: '#181818', width: '16px', height: '16px' }} />
    );
  } else if (
    workStatus === 'SCHEDULED' ||
    workStatus === 'scheduled' ||
    status === 'SCHEDULED' ||
    status === 'scheduled'
  ) {
    backgroundColor = liteGreen;
  } else if (workStatus === 'DELETED' || status === 'DELETED') {
    backgroundColor = red;
    icon = (
      <HighlightOffIcon
        style={{ color: '#ffffff', width: '16px', height: '16px' }}
      />
    );
  }
   /* else if (workStatus === 'COMPLETE' || status === 'COMPLETE') {
    backgroundColor = green;
    icon = (
      <CheckCircleOutlineIcon
        style={{ color: '#ffffff', width: '16px', height: '16px' }}
      />
    );
  } */

  const color = getCompatibleTextColor(backgroundColor);
  return (
    <Chip
      key={!status ? workStatus : status}
      label={!status ? workStatus : status}
      onDelete={() => {}}
      deleteIcon={icon}
      className="status-badge"
      style={{ backgroundColor, color, fontSize: '13px', borderRadius: '6px' }}
    />
  );
};

StatusChipField.defaultProps = {
  addLabel: true,
};

export default StatusChipField;
